





















































































































































import {PalabraInterface} from "@/models/Crucigrama";
import CardHeader from "@/components/CardHeader.vue"

const empty: { words: any[]; start?: any; letter?: any; empty?: any } = {
    start: false,
    letter: '',
    words: [] as any[],
    empty: true
};


import {Component, Mixins} from "vue-property-decorator";
import {BasicMixin} from "@/mixins/AdminMixin";
import {Getter, State} from "vuex-class";
import {SoupLetterInterface} from "@/models/Games";

@Component({
    components:{
        CardHeader
    }
})
export default class CrucigramaAdmin extends Mixins(BasicMixin){

   // @State(state => state.game.crucigrama) palabras: PalabraInterface[];

    public direcciones: any[] = [
        {title: 'Horizontal', number: 0},
        {title: 'Vertical', number: 1},
    ];
    public ejedata = 0;
    
    public headers = [
        {
            text: 'Palabra',
            align: 'left',
            sortable: true,
            value: 'palabra',
        },
        {
            text: 'Pista',
            align: 'left',
            sortable: true,
            value: 'pista',
        },
        {
            text: 'Dirección',
            align: 'left',
            sortable: true,
            value: 'sentido',
        },
        {
            text: 'Ubicación',
            align: 'left',
            sortable: true,
            value: 'pos',
        },
        { text: 'Opciones', value: 'actions' },
    ];

    public ejesXY: number[]= [];

    openModal(edit: boolean, item: PalabraInterface | any) {
        this.edit = edit;
        this.dialog = true;
        if (edit) {
            this.ejesXY = item.pos;
            this.idModel = item.id;
            this.palabra = {
                palabra: item.palabra,
                pista: item.pista,
                sentido: item.sentido,
                pos: item.pos,
                crucigramaId: this.$route.params.id
            }
        } else {
            this.ejesXY = [];

            this.palabra = {
                palabra: '',
                pista: '',
                sentido: 0,
                pos: [],
                crucigramaId: this.$route.params.id
            }
        }
    }


    public palabra: PalabraInterface = {
        id: '',
        palabra:'',
        pista:'',
        pos: [],
        sentido: 0,
        crucigramaId: ''
    };


    public completed = Array(5).fill(false);

    public matrix: any[] = [];
    // public palabras: PalabraInterface[] = [
    //     {
    //         pos: [0, 0],
    //         sentido: 0,
    //         palabra: 'gravedad',
    //         pista: 'Fuerza que nos mantiene unidos a la superficie del planeta'
    //     },
    //     {
    //         pos: [2, 0],
    //         sentido: 1,
    //         palabra: 'agua',
    //         pista: 'Compuesta por dos moléculas de hidrógeno y una de oxígeno'
    //     },
    //     {
    //         pos: [0, 3],
    //         sentido: 0,
    //         palabra: 'plantas',
    //         pista: 'Renuevan el aire que respiramos'
    //     },
    //     {
    //         pos: [4, 3],
    //         sentido: 1,
    //         palabra: 'tierra',
    //         pista: 'Planeta en donde vivimos'
    //     },
    //     {
    //         pos: [0, 5],
    //         sentido: 0,
    //         palabra: 'oxigeno',
    //         pista: 'Gas incoloro e inodoro esencial para la vida'
    //     }
    // ];


    dibujateTable(){
        const matrix = Array(9).fill(0).map(() => Array(8).fill(null).map(() => empty));
        this.palabras.forEach((palabra, index) => {
            const [x, y] = palabra.pos;
            palabra.palabra.split('').forEach((l, i) => {
                let cell: any = matrix[y + (palabra.sentido ? i : 0)][x + (palabra.sentido ? 0 : i)];
                if (cell === empty) {
                    cell = matrix[y + (palabra.sentido ? i : 0)][x + (palabra.sentido ? 0 : i)] = {words: []}
                }
                cell.empty = false;
                cell.words.push(index);
                if (i === 0) {
                    cell.start = index + 1;
                }
                cell.letter = l;
            })
        });

        this.matrix = matrix
    }

    get ejeStatus(): string{
        switch (this.ejesXY.length) {
            case 0:
                return 'Agrega eje x';

            case 1:
                return 'Agrega eje y';

            default:
                return 'Ejes Agregados'

        }
    }

    get palabras(): PalabraInterface[]{
        return this.$store.getters.crucigramaById( this.$route.params.id )
    }

    addEje(){
        this.ejesXY.push(this.ejedata);

        this.ejedata = 0;
    }

    removeElement(array: any[], index: number) {
        array.splice(index, 1);
    }
    removeEje( index: number ) {
        this.removeElement(this.ejesXY, index)
    }

    formSubmit(){
        this.palabra.pos = this.ejesXY;
        if (this.edit){
            this.$store.dispatch('editCollect', {id: this.idModel, data: this.palabra, collection: 'crucigrama'});
            this.text = 'Se ha editado la palabra';
            this.dialog = false;
            this.snackbar = true;
        } else {
            this.$store.dispatch('createdCrucigrama', this.palabra);
            this.text = 'Se ha creado la palabra';
            this.dialog = false;
            this.snackbar = true;
        }

    }

    deleteItem(item: SoupLetterInterface){
        this.$store.dispatch('deleteCollect', {id:item.id, collection:'crucigrama'})
    }

    created(){
        // this.$store.subscribeAction((action) => {
        //
        //     if (action.type === 'bindCrucigrama') {
        //         this.dibujateTable()
        //
        //     }
        //
        //     console.log(action.type);
        // });

        // this.$store.subscribe((mutation, state) => {
        //     if (state.game.crucigrama) {
        //         console.log('crucigrama mutacion', mutation);
        //         console.log(' crucigrama state', state.game.crucigrama)
        //     }
        // });

        this.$store.watch((state, getters) => state.game.crucigrama,
        (value, oldValue) => {
           this.dibujateTable();
        });

        this.$store.dispatch('bindCrucigrama');

    }
}
